import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="pt-40 pb-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-6 lg:px-16">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-6">
              Terms & Conditions
            </h1>
            <p className="text-lg text-gray-600">
              Last updated: December 14, 2024
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 lg:px-16">
          <div className="max-w-4xl space-y-12">
            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                By accessing and using the services of ETAN LLC ("Company," "we," "our," or "us"), you accept and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">2. Services</h2>
              <p className="text-gray-700 leading-relaxed">
                ETAN LLC provides marketing strategy, digital marketing, business consulting, and brand development services. The specific scope of services will be outlined in individual service agreements or proposals.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">3. Client Obligations</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Clients agree to:
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>Provide accurate and complete information necessary for service delivery</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>Respond to communications and requests in a timely manner</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>Make payments according to agreed terms</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>Comply with all applicable laws and regulations</span>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">4. Fees and Payment</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Fees for services will be specified in individual service agreements. Unless otherwise stated:
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>All fees are in US Dollars unless otherwise specified</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>Payment terms will be outlined in the service agreement</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>Late payments may incur interest charges</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">•</span>
                  <span>Fees are non-refundable unless otherwise agreed in writing</span>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">5. Intellectual Property</h2>
              <p className="text-gray-700 leading-relaxed">
                All materials, methodologies, and deliverables created by ETAN LLC in the course of providing services remain the intellectual property of ETAN LLC until full payment is received. Upon full payment, specified rights will be transferred to the client as outlined in the service agreement.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">6. Confidentiality</h2>
              <p className="text-gray-700 leading-relaxed">
                Both parties agree to maintain the confidentiality of any proprietary or confidential information disclosed during the course of the business relationship. This obligation continues after the termination of services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">7. Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed">
                ETAN LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to our services. Our total liability shall not exceed the fees paid by the client for the specific services giving rise to the claim.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">8. Termination</h2>
              <p className="text-gray-700 leading-relaxed">
                Either party may terminate services with written notice as specified in the service agreement. Upon termination, the client remains obligated to pay for all services rendered up to the termination date.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">9. Governing Law</h2>
              <p className="text-gray-700 leading-relaxed">
                These Terms and Conditions shall be governed by and construed in accordance with the laws of the United Arab Emirates. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of Dubai.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">10. Modifications</h2>
              <p className="text-gray-700 leading-relaxed">
                ETAN LLC reserves the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting on our website. Continued use of our services after changes constitutes acceptance of the modified terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 mb-4">11. Contact Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                For questions regarding these Terms and Conditions, please contact:
              </p>
              <div className="bg-gray-50 p-6 rounded">
                <p className="text-gray-700">
                  <strong>ETAN LLC</strong><br />
                  Dubai, United Arab Emirates<br />
                  Email: info@etanllc.com<br />
                  Website: etanllc.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;